// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/weight-definitions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/weight-definitions/weight-definitions.js';

mount([g0]);
